import TagManager, { TagManagerArgs } from 'react-gtm-module';
import { AnalyticsManager, PageViewOptions, TrackOptions } from 'ia-react-core';
import { buildPageViewDataLayer, buildTrackDataLayer, buildTrackFormDataLayer } from './dataLayerBuilder';
import { AnalyticsValues } from '../interfaces/AnalyticsValues';

class Analytics extends AnalyticsManager<AnalyticsValues> {
  constructor(gtmId: string, { ...options }) {
    super(options);
    if (window.location.host.toLowerCase().indexOf('localhost') === -1) {
      const disable = localStorage.getItem('disable-analytics');
      if (disable !== 'true') {
        this.processAnalytics = true;
        if (process.env.REACT_APP_ANALYTICS_USE_CSP !== 'true') {
          const tagManagerArgs: TagManagerArgs = { gtmId };
          TagManager.initialize(tagManagerArgs);
        }
      }
    }
    if (localStorage.getItem('omni-output-analytics') === 'true') {
      this.outputAnalytics = true;
      // eslint-disable-next-line no-console
      console.log('------ Analytics => Output mode is on');
    }
  }

  private outputAnalytics = false;
  private processAnalytics = false;

  pageView(options: PageViewOptions<AnalyticsValues>) {
    const dl = buildPageViewDataLayer(options);

    if (this.processAnalytics) {
      TagManager.dataLayer(dl);
    }

    if (this.outputAnalytics) {
      // eslint-disable-next-line no-console
      console.log('------ Analytics => pageView', JSON.stringify(dl));
    }
  }

  track(options: TrackOptions<AnalyticsValues>) {
    const dl = options?.values?.isForm ? buildTrackFormDataLayer(options) : buildTrackDataLayer(options);

    if (this.processAnalytics) {
      TagManager.dataLayer(dl);
    }

    if (this.outputAnalytics) {
      // eslint-disable-next-line no-console
      console.log('------ Analytics => track', JSON.stringify(dl));
    }
  }
}

export default Analytics;
